import { render } from "./editBaseInfo.vue?vue&type=template&id=176f2489&scoped=true&ts=true"
import script from "./editBaseInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./editBaseInfo.vue?vue&type=script&setup=true&lang=ts"

import "./editBaseInfo.vue?vue&type=style&index=0&id=176f2489&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176f2489"],['__file',"src/views/applications/pop/editBaseInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "176f2489"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('176f2489', __exports__)) {
    console.log('reload')
    api.reload('176f2489', __exports__)
  }
  
  module.hot.accept("./editBaseInfo.vue?vue&type=template&id=176f2489&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('176f2489', render)
  })

}


export default __exports__